var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.configuration)?_c('div',{staticClass:"attachment"},[_c(_vm.configuration.contentType,{key:_vm.configuration.id,tag:"component",attrs:{"id":_vm.configuration.id,"configuration":_vm.configuration}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }